import { useMemo } from 'react';
import { useCoderConfig } from './useCoderConfig';

export function useOpenInCoderLink(coderAccessUrl: string): string | null {
  const coderConfig = useCoderConfig();
  const newUrl = useMemo(() => {
    if (!coderAccessUrl || coderConfig === undefined) {
      return null;
    }

    const formattedParams = new URLSearchParams({
      mode: encodeURIComponent(coderConfig.createMode),
    });

    const rawParams = coderConfig.params;
    if (rawParams !== undefined && rawParams.hasOwnProperty) {
      for (const key in rawParams) {
        if (!rawParams.hasOwnProperty(key)) {
          continue;
        }

        formattedParams.append(
          encodeURIComponent(`param.${key}`),
          encodeURIComponent(rawParams[key]),
        );
      }
    }

    const safeTemplate = encodeURIComponent(coderConfig.template);
    return `${coderAccessUrl}/templates/${safeTemplate}/workspace?${formattedParams.toString()}`;
  }, [coderConfig, coderAccessUrl]);

  return newUrl;
}
